import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, doc, getDoc, limit, startAfter } from 'firebase/firestore'

const { db } = initFirebase()

export class FirebaseSystemLogService {
  async getAllSystemLogs() {
    const ref = collection(db, 'system_logs')
    const q = query(ref, orderBy('createdAt', 'desc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async getSystemLogsPaginated(pageSize = 40, lastDoc = null) {
    const ref = collection(db, 'system_logs')
    let q
    
    if (lastDoc) {
      q = query(ref, orderBy('createdAt', 'desc'), startAfter(lastDoc), limit(pageSize))
    } else {
      q = query(ref, orderBy('createdAt', 'desc'), limit(pageSize))
    }
    
    const snap = await getDocs(q)
    const logs = snap.docs.map(d => ({ id: d.id, ...d.data() }))
    const lastVisible = snap.docs[snap.docs.length - 1]
    
    return {
      logs,
      lastVisible,
      hasMore: snap.docs.length === pageSize
    }
  }

  async getLogById(logId) {
    const docRef = doc(db, 'system_logs', logId)
    const docSnap = await getDoc(docRef)
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() }
    }
    return null
  }
}
